var _path, _g, _g2, _g3, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33377 21.9155H5.50053C5.77668 21.9155 6.00055 22.1394 6.00055 22.4156V26.2974C6.00055 26.7162 6.48461 26.9494 6.81216 26.6884L12.6654 22.0245C12.754 21.954 12.8638 21.9155 12.977 21.9155H19.3344C20.8052 21.9155 22.0012 20.7243 22.0012 19.2595V8.6355C22.0012 7.17071 20.8052 5.97949 19.3344 5.97949H3.33377C1.86304 5.97949 0.666992 7.17071 0.666992 8.6355V19.2595C0.666992 20.7243 1.86304 21.9155 3.33377 21.9155Z",
    fill: "url(#paint0_linear_26293_14587)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26293_14587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81882 15.9736C6.82306 15.9736 7.63715 15.1595 7.63715 14.1552C7.63715 13.151 6.82306 12.3369 5.81882 12.3369C4.81458 12.3369 4.00049 13.151 4.00049 14.1552C4.00049 15.1595 4.81458 15.9736 5.81882 15.9736Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_26293_14587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.122 15.9736C12.1263 15.9736 12.9404 15.1595 12.9404 14.1552C12.9404 13.151 12.1263 12.3369 11.122 12.3369C10.1178 12.3369 9.30371 13.151 9.30371 14.1552C9.30371 15.1595 10.1178 15.9736 11.122 15.9736Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_26293_14587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4258 15.9736C17.43 15.9736 18.2441 15.1595 18.2441 14.1552C18.2441 13.151 17.43 12.3369 16.4258 12.3369C15.4215 12.3369 14.6074 13.151 14.6074 14.1552C14.6074 15.1595 15.4215 15.9736 16.4258 15.9736Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.6679 0.668945H8.66727C7.19654 0.668945 6.00049 1.86016 6.00049 3.32495H22.0012C23.4719 3.32495 24.6679 4.51617 24.6679 5.98096V16.605C26.1387 16.605 27.3347 15.4138 27.3347 13.949V3.32495C27.3347 1.86016 26.1387 0.668945 24.6679 0.668945Z",
    fill: "url(#paint1_linear_26293_14587)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26293_14587",
    x: -10.6911,
    y: -2.35464,
    width: 33.0198,
    height: 33.0198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.34578
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26293_14587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26293_14587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_26293_14587",
    x: -5.38784,
    y: -2.35464,
    width: 33.0198,
    height: 33.0198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.34578
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26293_14587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26293_14587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_26293_14587",
    x: -0.0841284,
    y: -2.35464,
    width: 33.0198,
    height: 33.0198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.34578
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26293_14587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26293_14587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26293_14587",
    x1: 0.222529,
    y1: 3.42127,
    x2: 21.9142,
    y2: 27.6472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26293_14587",
    x1: -16.2227,
    y1: -3.14907,
    x2: 13.8692,
    y2: 41.8877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.620957a70cb64d501bf2db7affb99a90.svg";
export { ForwardRef as ReactComponent };